import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import LetterDataTable from './LetterDataTable';

interface ILetterDataProps extends RouteComponentProps<{
  eshop: string;
  letterDataId: string;
}> {

}

export default class LetterData extends React.Component<ILetterDataProps> {

  render() {
    return (
      <div>
        <LetterDataTable
          domain={this.props.match.params.eshop}
          letterDataId={this.props.match.params.letterDataId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/LetterData/index.tsx